import { LayoutHOC } from 'base/ui/layout/layout';
import { createProductRouting } from './productRouting';

export const createProductRoutingPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createProductRouting());
};
